export default __webpack_public_path__ + "static/media/Tim Hortons - Logo3.705eecba.png";